// extracted by mini-css-extract-plugin
export default {"hero":"AboutUsView_hero__yja-s"};